<template>
  <div class="w-100 h-100 m-0" style="padding: 32px">
    <div class="d-flex flex-column align-items-center" style="gap: 40px;">
      <div class="m-0 p-0 acry-page-title justify-content-center">ACRY TICKET</div>

      <div class="d-flex" style="height: 360px; gap: 24px; width: 1024px;">
        <div class="position-relative w-50">
          <div class="h-100 mx-auto product-img product-img1" style="margin: 0px 16px; width: 500px;" />
          <div class="h-100 mx-auto product-img product-img2" style="margin: 0px 16px; width: 500px;" />
        </div>
        <div class="d-flex flex-column w-50" style="width: 500px;">
          <div class="m-0 p-0 acrypro-text-main-bold text-start d-flex align-items-center" style="height: 35px; border-bottom: solid 1px #8C9BC6;">
            <div class="ms-0">サービス内容</div>
          </div>
          <div class="acrypro-text-main-bold text-start" style="font-size: 15px; font-weight: 400;">
            <p class="m-0">「ACRY TICKET」を通じて、オリジナルデザインのアクリルプレートをエンドユーザーに配布できるサービスです。</p>
            <p class="m-0">プレートの制作費は企業が負担し、ユーザーは無料で注文可能。<span style="font-size: 13px;">（※送料がかかる場合あり）</span></p>
            <p class="m-0">プロモーションやブランドPR、イベントノベルティとして幅広く活用いただけます。</p>
            <p class="c-pointer mb-0" style="text-decoration: underline; color: #8C9BC6; margin-top: 15px;" @click="setModal(true)">サービスの詳しい概要についてはこちら</p>
          </div>
          <button class="mx-0 mb-0 acry-btn fw-bold" style="width: 300px; height: 54px; border-radius: 100px; font-size: 20px; margin-top: 24px;" @click="onClickEventCreate">
            チケット作成
          </button>
          <button class="mx-0 mb-0 acry-btn-sub fw-bold" style="width: 300px; height: 54px; border-radius: 100px; font-size: 20px; margin-top: 24px;" @click="onClickEventList">
            チケット一覧
          </button>
        </div>
      </div>

      <div class="d-flex flex-column text-start" style="padding: 24px; border-radius: 20px; background: #F8F8F8; gap: 24px; max-width: 1050px;">
        <div class="d-flex flex-column" style="gap: 8px;">
          <div>■作成手順</div>
          <div class="d-flex" style="gap: 30px;">
            <div class="d-flex flex-column justify-content-center align-items-center" style="width: 320px; height: 154px; border: solid 1px #8C9BC6; border-radius: 20px; gap: 16px; padding: 16px;">
              <div class="d-flex" style="gap: 6px;">
                <img src="@/assets/acrypro/coupon/step1.svg" />
                <p class="m-auto fw-bold" style="font-size: 16px;">PRページを作成</p>
              </div>
              <div style="font-size: 12px; margin-bottom: 12px;">ACRYアプリで掲載されるページを作成します。</div>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center" style="width: 320px; height: 154px; border: solid 1px #8C9BC6; border-radius: 20px; gap: 16px; padding: 16px;">
              <div class="d-flex" style="gap: 6px;">
                <img src="@/assets/acrypro/coupon/step2.svg" />
                <p class="m-auto fw-bold" style="font-size: 16px;">デザインを登録</p>
              </div>
              <div style="font-size: 12px; margin-bottom: 12px;">チケットコードで制作できるアクリルデザインを登録します。</div>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center" style="width: 320px; height: 154px; border: solid 1px #8C9BC6; border-radius: 20px; gap: 16px; padding: 16px;">
              <div class="d-flex" style="gap: 6px;">
                <img src="@/assets/acrypro/coupon/step3.svg" />
                <p class="m-auto fw-bold" style="font-size: 16px;">チケットコード発行・決済</p>
              </div>
              <div style="font-size: 12px; margin-bottom: 12px;">発行数・有効期限を決めて決済します。</div>
            </div>
          </div>
        </div>
        <div>
          <div style="font-size: 15px;">■チケット作成に必要なデータ</div>
          <div class="d-flex" style="border-bottom: solid 1px #D1D5DB; gap: 38px; font-size: 13px; padding-left: 16px; margin-top: 4px;">
            <div style="width: 180px;">PR画像（任意）</div>
            <div style="width: 100px;">PNG / JPEG</div>
            <div>アプリ内でのPRページに使用します。</div>
          </div>
          <div class="d-flex" style="border-bottom: solid 1px #D1D5DB; gap: 38px; font-size: 13px; padding-left: 16px; margin-top: 4px;">
            <div style="width: 180px;">デザインデータ</div>
            <div style="width: 100px;">PNG</div>
            <div>印刷されるアクリルのデザインです。</div>
          </div>
          <div class="d-flex" style="border-bottom: solid 1px #D1D5DB; gap: 38px; font-size: 13px; padding-left: 16px; margin-top: 4px;">
            <div style="width: 180px;">カットラインデータ</div>
            <div style="width: 100px;">SVG</div>
            <div>加工範囲を示すデータです。</div>
          </div>
          <div style="font-size: 12px; margin-top: 4px;">⚫︎デザイン作成の詳しい方法は<span class="c-pointer mb-0" style="text-decoration: underline; color: #8C9BC6; margin-top: 15px;" @click="onClickHelp()">ご利用ガイド</span>をご参考にしてください。</div>
        </div>
      </div>

      <div class="d-flex flex-column text-start" style="gap: 24px; max-width: 1050px;">
        <div class="m-0 p-0 w-100 acrypro-text-main-bold d-flex align-items-center" style="height: 35px; border-bottom: solid 1px #8C9BC6;">
          <div class="ms-0 w-100">ACRY TICKETで登録するアクリルデザインの特徴</div>
        </div>
        <div>
          <p class="m-0" style="font-size: 15px;">アクリルデザインを登録時に、ユーザー編集を可能にするか設定することができます。</p>
          <p class="m-0" style="font-size: 15px;">ロゴやブランド名など変更されたくない要素を固定しつつ、ブランドイメージを守りながらユーザー体験を向上させることができます。</p>
        </div>
        <div class="d-flex" style="gap: 16px;">
          <img src="@/assets/acrypro/coupon/ticket_ex1.svg" style="width: 179px; height: 253px;"/>
          <img src="@/assets/acrypro/coupon/ticket_ex2.svg" style="width: 179px; height: 253px;"/>
          <div class="d-flex flex-column" style="gap: 8px; width: 666px;">
            <div class="d-flex" style="background: #F5F7FA; height: 36px;">
              <div class="my-auto" style="padding: 8px; font-size: 15px;">ユーザー編集・可</div>
            </div>
            <div>
              <p class="m-0">ACRY TICKETで登録したデザインを元に、ACRYアプリでエンドユーザーは自由にカスタマイズが可能となります。</p>
              <p class="m-0">例えば、企業ロゴやビジュアルが描かれたアクリルデザインを元に、エンドユーザーが名前・写真・コメントなどを入れて“自分だけの特別な一枚”が作れるようになります。</p>
              <p class="m-0">登録されたデザインは保護されるので、デザインが崩れることはありません。</p>
            </div>
            <img src="@/assets/acrypro/coupon/ticket_text1.svg" style="width: 246px; height: 20px; margin-top: 16px;"/>
          </div>
        </div>
        <div class="d-flex" style="gap: 16px;">
          <img src="@/assets/acrypro/coupon/ticket_ex3.svg" style="width: 179px; height: 253px;"/>
          <img src="@/assets/acrypro/coupon/ticket_ex4.svg" style="width: 179px; height: 253px;"/>
          <div class="d-flex flex-column" style="gap: 8px; width: 666px;">
            <div class="d-flex" style="background: #F5F7FA; height: 36px;">
              <div class="my-auto" style="padding: 8px; font-size: 15px;">ユーザー編集・不可</div>
            </div>
            <div>
              <p class="m-0">ユーザー編集ができません。</p>
              <p class="m-0">登録したデザインのまま注文されます。</p>
              <p class="m-0">ACRY TICKET（チケットコード）を持っている人だけが入手できる特別仕様や、イベント配布やキャンペーンなど、レアな体験価値を提供します。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PR説明モーダル -->
    <div v-if="isShowModal" class="modal-bg" @click="setModal(false)">
      <div class="d-flex flex-column justify-content-center align-items-center position-relative" style="width: 1100px; height: 700px; border-radius: 8px; background: #FEFEFE; padding: 40px 0px; gap: 24px;" v-on:click.stop="">
        <img class="position-absolute c-pointer" style="top: 40px; right: 40px;" src="@/assets/acrypro/close.svg" @click="setModal(false)">
        <div class="fw-bold" style="font-size: 28px;">
          ACRY TICKET（アクリーチケット）について
        </div>
        <div class="d-flex flex-column " style="overflow-y: scroll;">
          <div class="text-start" style="font-size: 15px;">
            <p class="mt-0" style="margin-bottom: 15px;">本サービスは、企業がプロモーションや販促活動で活用できるアクリルプレートをエンドユーザーに配布できるサービスです。</p>
            <p class="m-0">● チケットコードは10桁の英数字です。</p>
            <p class="m-0">● チケットコードを配布することで、自社PRやイベントのノベルティとして活用できます。</p>
            <p class="m-0">● デザインは企業が用意し、チケットコード発行時に登録します。</p>
            <p class="m-0">● エンドユーザーはチケットコードを利用して、アクリルプレートを制作できます。</p>
            <p class="mt-0" style="margin-bottom: 15px;">● アクリルプレートの制作費は企業が負担し、エンドユーザーは無料で注文できます。（※設定により、別途送料が発生する場合があります。）</p>
            <p class="m-0">エンドユーザーは、ACRYアプリ(※現在はiOS版のみ対応）にチケットコードを入力することで、企業デザインのアクリルプレートをお得に注文できます。</p>
            <p class="m-0">企業は低コストでブランド露出を強化、エンドユーザーは 魅力的なアイテムを手軽に入手できる、双方にメリットのある仕組みです。</p>
          </div>
          <img style="height: 600px; object-fit: contain; margin-top: 32px;" src="@/assets/acrypro/coupon/top_info.png" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { CenterViewState } from "@/js/Const.js";
import { Analytics } from "@/js/Analytics.js";

export default {
  name: "CenterViewEventManagement_Ap",
  props: {},
  data: function () {
    return {
      isShowModal: false,

    };
  },
  computed: {

  },
  async created() {
    this.$store.state.centerViewRef.scrollTop = 0;
    this.$store.commit("hideRightMenu");

    this.$store.commit("showLoading");

    await this.$store.state.acrylicTicketCouponManager.resetEditData();

    this.$store.commit("hideLoading");
  },
  components: {
  },
  methods: {
    setModal(isShow){
      this.isShowModal = isShow;
    },
    onClickHelp(){
      window.open('https://www.acry.jp/datacreationguide');
    },
    onClickEventCreate(){
      Analytics.acryTicketCreateButtonClick();

      // イベント作成画面に遷移する前にデータをリセット
      this.$store.commit("resetEventCreateData");
      this.$store.commit("setCenterViewState", CenterViewState.EventCreate);
    },
    onClickEventList(){
      // イベント作成画面に遷移する前にデータをリセット
      this.$store.commit("resetEventCreateData");
      this.$store.commit("setCenterViewState", CenterViewState.EventList);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

@keyframes image-switch-animation {
  0%{ opacity: 0;}
  50%{ opacity: 1;}
  100%{ opacity: 0;}
}

.product-img {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  border-radius: 20px;
  background-size: cover;
  background-position: center center;
  animation: image-switch-animation 10s infinite;
}

.product-img1 {
  background-image: url("~@/assets/acrypro/sample_order_product1.png");
}

.product-img2 {
  background-image: url("~@/assets/acrypro/sample_order_product2.png");
}

.product-img:nth-of-type(1) {
  animation-delay: 0s;
}
.product-img:nth-of-type(2) {
  animation-delay: 5s;
}

.acry-btn-sub {
  // margin: 10px;
  padding: 3px 30px;
  color: $primary-main-color;
  background-color: #ffffff;
  border: solid 2px $border-main-color;
  border-radius: 15px;
  font-size: 15px;
}

.modal_bg {
  background-color: rgba(0.5, 0.5, 0.5, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}

.ticket-modal {
  position: relative;
  width: 830px;
  height: 85%;
  background-color: white;
  border-radius: 15px;
}
</style>


